export default __webpack_public_path__ + "static/media/Search_Dark2.01f6d485.svg";